/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AlertData, AlertReplayResponse, AlertRequest } from 'models/viewModels';
import { alertApi } from './AlertApi';

class AlertService {
  async getAlertBackfill(parameters: AlertRequest): Promise<AlertData[]> {
    return alertApi.getAlertBackfill(parameters);
  }

  async getAlertReplay(parameters: AlertRequest): Promise<AlertReplayResponse> {
    return alertApi.getAlertReplay(parameters);
  }
}

export const alertService = new AlertService();
